import {SET_MENU} from '../constants'; 


export const setMenu = (payload) => {
    return{
        type: SET_MENU,
        payload: payload,
    }
}
